module.exports = __webpack_public_path__ + "static/media/sample_report2.e2177caf.png";